var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01447a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m894.07 461.34c0 162.41-131.66 294.07-294.07 294.07s-294.07-131.66-294.07-294.07 131.66-294.08 294.07-294.08 294.07 131.66 294.07 294.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m786 725.42c-52.648 37.176-116.79 59.117-186 59.117s-133.35-21.93-185.98-59.117c-181.01 24.379-308.7 99.914-308.7 307.31h989.36c0.003907-207.39-127.66-282.93-308.68-307.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.9969a43bbadb4ffa7b59ec112b97f2ba.svg";
export { ForwardRef as ReactComponent };